export default __webpack_public_path__ + "static/media/search.25c76ac6.svg";